import { fetchAuthSession } from 'aws-amplify/auth';

// Helper function to get auth token
export const getAuthToken = async (): Promise<string | null> => {
    try {
        const session = await fetchAuthSession();
        return session.tokens?.accessToken?.toString() || null;
    } catch (error) {
        console.error('Error getting auth token:', error);
        return null;
    }
};

// Helper function to get auth headers
export const getAuthHeaders = async (): Promise<Record<string, string>> => {
    const token = await getAuthToken();
    const headers: Record<string, string> = {
        'Content-Type': 'application/json'
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
};
